import { Application } from "@hotwired/stimulus"


const application = Application.start()

// Manually import each controller
import HelloController from "./hello_controller"
import PillNavbar from "../components/PillNavbar"
//import FooController from "./foo_controller"

// Register controllers with names (use the file name or any identifier you choose)
application.register("hello", HelloController)
//application.register("foo", FooController)
